import React, { type ReactElement } from 'react';
import type {
  UIFieldDefinition,
  UIFields
} from '../../utils/prepareSendIssueFields';
import {
  Accordion,
  AccordionContent,
  AccordionTrigger
} from '@deque/cauldron-react';
import styles from './ProvideValues.css';
import { useTranslation } from 'react-i18next';
import { ProvideValuesComponent } from './ProvideValuesComponent';

export interface ProvideValuesProps {
  uiFields?: UIFields;
  setUIFields: (value: React.SetStateAction<UIFields | undefined>) => void;
}

export const ProvideValues = ({
  uiFields,
  setUIFields
}: ProvideValuesProps): ReactElement => {
  const { t } = useTranslation();

  if (!uiFields) {
    return <div>{t('Error')}</div>;
  }

  return (
    <div className={styles.setValuesContainer}>
      <Accordion open={true}>
        <AccordionTrigger>{t('Required Fields')}</AccordionTrigger>
        <AccordionContent>
          {uiFields.requiredFields.map((uiField, index) => {
            return (
              <ProvideValuesComponent
                key={uiField.key}
                uiField={uiField}
                isRequired={true}
                setUIField={(updatedUIField: UIFieldDefinition) => {
                  uiFields.requiredFields[index] = updatedUIField;

                  setUIFields({ ...uiFields });
                }}
              />
            );
          })}
        </AccordionContent>
      </Accordion>
      <Accordion>
        <AccordionTrigger>{t('All Other Fields')}</AccordionTrigger>
        <AccordionContent>
          {uiFields.nonRequiredFields.map((uiField, index) => {
            return (
              <ProvideValuesComponent
                key={uiField.key}
                uiField={uiField}
                isRequired={false}
                setUIField={(updatedUIField: UIFieldDefinition) => {
                  uiFields.nonRequiredFields[index] = updatedUIField;

                  setUIFields({ ...uiFields });
                }}
              />
            );
          })}
        </AccordionContent>
      </Accordion>
    </div>
  );
};
